import { Options as CalculatorOptions } from '.'

import lazyCalculator from './lazy'

import type { RenderLoader } from '../types'

interface Options extends CalculatorOptions {
  priceTableRenderLoader: RenderLoader
  priceTableRenderMountPointId: string
}

export default function lazyCalculatorWithPriceTable(renderLoader: RenderLoader, mountPointId: string, options: Options) {
  const priceTableMountPoint = document.getElementById(options.priceTableRenderMountPointId) as HTMLElement

  let observer!: IntersectionObserver

  // Start calculator
  lazyCalculator(renderLoader, mountPointId, {
    lazyStoreManagerLoader: options.lazyStoreManagerLoader,

    mediaQuery: options.mediaQuery,
  })

  // Start emails collector
  if (typeof window.IntersectionObserver !== 'undefined') {
    observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        priceTable()
      }
    }, {
      rootMargin: "2000px",
      threshold: 1.0,
    })
    observer.observe(priceTableMountPoint)
  } else {
    priceTable()
  }

  async function priceTable() {
    observer?.disconnect()

    await (await options.lazyStoreManagerLoader()).initializing;

    (await options.priceTableRenderLoader())
      .render(priceTableMountPoint)
  }
}
